import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { resourceGetLanguage, resourceDefaultLanguage } from './api/resources';

Vue.use(VueI18n);

export const i18n = new VueI18n({
    messages: getLanguages(),
});

function loadFallbackLanguage() {
    resourceDefaultLanguage()
        .then(({ data }) => {
            let csv = csvToJson(data);
            if (Object.keys(csv).length === 0) {
                return Promise.reject();
            }
            setLocale('defaultLang', csv);
        })
        // there is no other way...
        .catch(() => console.error('Cannot load appropriate i18n file'));
}

async function getLanguages() {
    resourceGetLanguage()
        .then(({ data }) => {
            let csv = csvToJson(data);
            if (Object.keys(csv).length === 0) {
                // empty i18n files isn't suitable at all
                console.warn('i18n file is empty, falling back to default language');
                return Promise.reject();
            }
            setLocale('customLang', csv);
        })
        // fall back if something gone wrong (i.e. network error)
        .catch(() => {
            // console.warn('Error loading i18n file, falling back to default language');
            loadFallbackLanguage();
        });
}

function setLocale(lang, json) {
    i18n.setLocaleMessage(lang, json);
    i18n.locale = lang;
}

/**
 * Convert plain csv data to json. In case of error it returns reject.
 * @param data
 * @returns {Promise}
 */
export const csvToJson = data =>
    data
        .split('\n')
        // trim starting/trailing whitespaces
        .map(Function.prototype.call, String.prototype.trim)
        // skip empty lines
        .filter(Boolean)
        // ignore backend-related i18n records
        .filter(line => !line.startsWith('be.'))
        .reduce((acc, line) => {
            let parts = line.split(/,(.*)/).slice(0, -1);
            // unescaping the value right on the way
            acc[parts[0]] = parts[1].replace(/^"(.*)"$/, '$1');
            return acc;
        }, {});
